import React, { Fragment } from 'react'
import Header from '../components/layouts/Header'
import Footer from '../components/layouts/Footer'
import DeveloperType from '../features/registrationstep/DeveloperType'
import { useSelector } from 'react-redux'
import SkillType from '../features/registrationstep/SkillType'
import Developer from '../features/registrationstep/Developer'
import SimplifySection from '../features/common/SimplifySection'
import CodingBackground from '../assets/common/CodingBackground.png'
import useDocumentTitle from '../hooks/useDocumentTitle';
import PreviouslyRockedAt from '../features/common/PreviouslyRockedAt'


const StartHiring = () => {
    useDocumentTitle("Start Hiring");

    const { hire_registration: { step } } = useSelector(state => state.common);
    const backgroundStyle = {
        backgroundImage: `url(${CodingBackground})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
    }

    return (
        <Fragment>
            <Header />
            <main className="" style={backgroundStyle}>
                <section className="--layout-padding max-width">
                    <div className="container">
                        {step === 1 && <DeveloperType />}
                        {step === 2 && <SkillType />}
                        {step === 3 && <Developer />}
                    </div>
                </section>
                {[1, 2].includes(step) && <div className="ourTalant">
                    <PreviouslyRockedAt />
                </div>}
                {step === 3 && <SimplifySection />}
            </main>
            <Footer />
        </Fragment>
    )
}

export default StartHiring